import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UserProfile from './UserProfile';
import AuthModal from './AuthModal';

const Navigation = () => {
  const { isAuthenticated, isGuest } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleAuthModalClose = () => {
    setShowAuthModal(false);
  };

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/iq-test-logo-optimized.png"
                alt="IQ Test Logo"
                className="h-10 w-auto"
                style={{ objectFit: 'contain', objectPosition: 'center' }}
              />
              <span className="text-xl font-bold text-gray-900">IQ Test</span>
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <Link
              to="/leaderboard"
              className="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
            >
              Leaderboard
            </Link>

            {isGuest && (
              <button
                onClick={() => setShowAuthModal(true)}
                className="bg-yellow-50 border border-yellow-200 px-3 py-1 rounded-lg hover:bg-yellow-100 transition-colors cursor-pointer"
                title="Click to sign in"
              >
                <span className="text-yellow-800 text-sm">Guest Mode - Click to Sign In</span>
              </button>
            )}

            <UserProfile />

            {!isAuthenticated && !isGuest && (
              <button
                onClick={() => setShowAuthModal(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm font-medium"
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={handleAuthModalClose}
        title="Sign In"
        subtitle="Sign in to save your scores and access additional features, or continue as a guest."
      />
    </nav>
  );
};

export default Navigation;
